import React from "react";
import { NavLink } from "react-router-dom";
import {
  AuditOutlined,
  BarChartOutlined,
  BellOutlined,
  BgColorsOutlined,
  CalendarOutlined,
  ContactsOutlined,
  DatabaseOutlined,
  FileSearchOutlined,
  FormOutlined,
  PictureOutlined,
  ShoppingCartOutlined,
  StopOutlined,
  TeamOutlined,
  TransactionOutlined,
  UserAddOutlined,
  SafetyOutlined,
} from "@ant-design/icons";

const iconStyle = {
  fontSize: 18,
  color: "#fff",
  width: 18,
  minWidth: 18,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
};
const superAdminLinkStyle = {
  color: "#fff",
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

import { getItem } from "../utils";

const superAdminGroupsSideNavLink = getItem(
  <NavLink
    to="/superadmin/groups"
    className="nav-link default-text-color"
    style={superAdminLinkStyle}
  >
    <span style={{ color: "#fff" }}>Groups</span>
  </NavLink>,
  "/superadmin/groups",
  <TeamOutlined style={iconStyle} />
);

const superAdminRegistrationsSideNavLink = getItem(
  <NavLink
    to="/superadmin/registrations"
    className="nav-link default-text-color"
    style={superAdminLinkStyle}
  >
    <span style={{ color: "#fff" }}>Registrations</span>
  </NavLink>,
  "/superadmin/registrations",
  <FormOutlined style={iconStyle} />
);

const superAdminAdoptionSideNavLink = getItem(
  <NavLink
    to="/superadmin/adoption"
    className="nav-link default-text-color"
    style={superAdminLinkStyle}
  >
    <span style={{ color: "#fff" }}>Adoption</span>
  </NavLink>,
  "/superadmin/adoption",
  <UserAddOutlined style={iconStyle} />
);

const superAdminMissingTransactionsSideNavLink = getItem(
  <NavLink
    to="/superadmin/missing-transactions"
    className="nav-link default-text-color"
    style={superAdminLinkStyle}
  >
    <span style={{ color: "#fff" }}>Missing Transactions</span>
  </NavLink>,
  "/superadmin/missing-transactions",
  <FileSearchOutlined style={iconStyle} />
);

const superAdminDirectorySideNavLink = getItem(
  <NavLink
    to="/superadmin/directory"
    className="nav-link default-text-color"
    style={superAdminLinkStyle}
  >
    <span style={{ color: "#fff" }}>Directory</span>
  </NavLink>,
  "/superadmin/directory",
  <ContactsOutlined style={iconStyle} />
);

const superAdminReferralsSideNavLink = getItem(
  <NavLink
    to="/superadmin/referrals"
    className="nav-link default-text-color"
    style={superAdminLinkStyle}
  >
    <span style={{ color: "#fff" }}>Referrals</span>
  </NavLink>,
  "/superadmin/referrals",
  <AuditOutlined style={iconStyle} />
);

const superAdminPollsSideNavLink = getItem(
  <NavLink
    to="/superadmin/polls"
    className="nav-link default-text-color"
    style={superAdminLinkStyle}
  >
    <span style={{ color: "#fff" }}>Polls</span>
  </NavLink>,
  "/superadmin/polls",
  <BarChartOutlined style={iconStyle} />
);

const superAdminTransactionsSideNavLink = getItem(
  <NavLink
    to="/superadmin/report/transactions"
    className="nav-link default-text-color"
    style={superAdminLinkStyle}
  >
    <span style={{ color: "#fff" }}>Transactions</span>
  </NavLink>,
  "/superadmin/report/transactions",
  <TransactionOutlined style={iconStyle} />
);

const superAdminMatchDaySideNavLink = getItem(
  <NavLink
    to="/superadmin/status/report"
    className="nav-link default-text-color"
    style={superAdminLinkStyle}
  >
    <span style={{ color: "#fff" }}>Match Day</span>
  </NavLink>,
  "/superadmin/status/report",
  <CalendarOutlined style={iconStyle} />
);

const superAdminDeactivatedSideNavLink = getItem(
  <NavLink
    to="/superadmin/deactivated"
    className="nav-link default-text-color"
    style={superAdminLinkStyle}
  >
    <span style={{ color: "#fff" }}>Deactivated</span>
  </NavLink>,
  "/superadmin/deactivated",
  <StopOutlined style={iconStyle} />
);

const superAdminDataSideNavLink = getItem(
  <NavLink
    to="/superadmin/data"
    className="nav-link default-text-color"
    style={superAdminLinkStyle}
  >
    <span style={{ color: "#fff" }}>Data</span>
  </NavLink>,
  "/superadmin/data",
  <DatabaseOutlined style={iconStyle} />
);

const superAdminDesignSideNavLink = getItem(
  <NavLink
    to="/superadmin/design"
    className="nav-link default-text-color"
    style={superAdminLinkStyle}
  >
    <span style={{ color: "#fff" }}>Design</span>
  </NavLink>,
  "/superadmin/design",
  <PictureOutlined style={iconStyle} />
);

const superAdminPackagesSideNavLink = getItem(
  <NavLink
    to="/superadmin/packages"
    className="nav-link default-text-color"
    style={superAdminLinkStyle}
  >
    <span style={{ color: "#fff" }}>Packages</span>
  </NavLink>,
  "/superadmin/packages",
  <ShoppingCartOutlined style={iconStyle} />
);

const superAdminAlertsSideNavLink = getItem(
  <NavLink
    to="/superadmin/alerts"
    className="nav-link default-text-color"
    style={superAdminLinkStyle}
  >
    <span style={{ color: "#fff" }}>Alerts</span>
  </NavLink>,
  "/superadmin/alerts",
  <BellOutlined style={iconStyle} />
);

const superAdminColorsSideNavLink = getItem(
  <NavLink
    to="/superadmin/colors"
    className="nav-link default-text-color"
    style={superAdminLinkStyle}
  >
    <span style={{ color: "#fff" }}>Colors</span>
  </NavLink>,
  "/superadmin/colors",
  <BgColorsOutlined style={iconStyle} />
);

const superAdminUserRolesSideNavLink = getItem(
  <NavLink
    to="/superadmin/user-roles"
    className="nav-link default-text-color"
    style={superAdminLinkStyle}
  >
    <span style={{ color: "#fff" }}>User Roles</span>
  </NavLink>,
  "/superadmin/user-roles",
  <SafetyOutlined style={iconStyle} />
);

export default [
  superAdminGroupsSideNavLink,
  superAdminRegistrationsSideNavLink,
  superAdminAdoptionSideNavLink,
  superAdminMissingTransactionsSideNavLink,
  superAdminDirectorySideNavLink,
  superAdminReferralsSideNavLink,
  superAdminPollsSideNavLink,
  superAdminTransactionsSideNavLink,
  superAdminMatchDaySideNavLink,
  superAdminDeactivatedSideNavLink,
  superAdminDataSideNavLink,
  superAdminDesignSideNavLink,
  superAdminPackagesSideNavLink,
  superAdminAlertsSideNavLink,
  superAdminColorsSideNavLink,
  superAdminUserRolesSideNavLink,
];
